import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const gameDataRoutes: RouteRecordRaw[] = [
  {
    path: '/game-data',
    name: 'GameData',
    component: Layout,
    meta: { title: '游戏运行', icon: 'vi-ep:data-board', alwaysShow: true },
    children: [
      {
        path: 'goods',
        component: () => import('@/views/Game/GameGoodsList.vue'),
        name: 'GameGoodsList',
        meta: { title: '用户背包' }
      },
      {
        path: 'room-config',
        component: () => import('@/views/Game/RoomConfigList.vue'),
        name: 'RoomConfigList',
        meta: { title: '房间匹配' }
      },
      {
        path: 'scaling',
        component: () => import('@/views/Game/ScalingPolicyList.vue'),
        name: 'ScalingPolicyList',
        meta: { title: '弹性策略' }
      },
      {
        path: 'node',
        component: () => import('@/views/Game/ServerNodeList.vue'),
        name: 'ServerNodeList',
        meta: { title: '节点管理' }
      },
      {
        path: 'candy-asset',
        component: () => import('@/views/Game/CandyAssetLogList.vue'),
        name: 'CandyAssetLogList',
        meta: { title: '糖果资产流水' }
      },
      {
        path: 'candy-battle',
        component: () => import('@/views/Game/CandyBattleRecordList.vue'),
        name: 'CandyBattleRecordList',
        meta: { title: '糖果对战' }
      }
    ]
  }
]

export default gameDataRoutes
